// eslint-disable-next-line no-restricted-imports
import { createAsyncThunk } from '@reduxjs/toolkit';
import type { AsyncThunkPayloadCreator } from '@reduxjs/toolkit';
import type { NormalizedError } from '@/types/NormalizedError';
import type { RootState, AppDispatch } from './store';

type AppThunkConfig = {
  state: RootState;
  dispatch: AppDispatch;
  rejectValue: NormalizedError;
};

// Use this instead of createAsyncThunk.
// This is a wrapper for createAsyncThunk that uses built in NormalizedError
export function createAppThunk<Returned, ThunkArg = void>(
  typePrefix: string,
  payloadCreator: AsyncThunkPayloadCreator<Returned, ThunkArg, AppThunkConfig>,
) {
  return createAsyncThunk<Returned, ThunkArg, AppThunkConfig>(typePrefix, payloadCreator);
}
